export default __webpack_public_path__ + "static/synology-0b34f4b8279893f5e28cae926a99a098.jpg";